import React, { useEffect } from "react";
import {
  Form,
  Button,
  Input,
  Upload,
  message,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import {
  getBussinesCradSerial,
  getCard,
  updatePCard,
} from "../store/actions/pcardAction";
import { useNavigate } from "react-router-dom";

const EditPcardForm = ({ translate, cardId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  useEffect(() => {
    dispatch(getCard(cardId))
      .unwrap()
      .then((res) => {
        form.setFieldsValue({
          ...res,
          createdDate: res.createdDate ? dayjs(res.createdDate) : null,
          cardImage: res.cardImage
            ? [{
              uid: '-1',
              name: res.cardImage.split("/").pop(),
              status: 'done',
              url: res.cardImage,
            }]
            : []
        });
      })
      .catch((err) => {
        message.error(String(err), 4);
      });
  }, [dispatch, cardId, form]);
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const onFinish = (values) => {
    const formData = new FormData();
    const formattedDate = values.createdDate
      ? dayjs(values.createdDate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
    if (values.cardImage && values.cardImage.length > 0) {
      values.cardImage.forEach((fileItem) => {
        if (fileItem.originFileObj) {
          formData.append("cardImage", fileItem.originFileObj);
        }
      });
    }
    Object.keys(values).forEach((key) => {
      if (key !== "createdDate" && key !== "cardImage") {
        if (values[key] !== undefined && values[key] !== null) {
          formData.append(key, values[key]);
        }
      }
    });
    formData.append("createdDate", formattedDate);
    const payload = {
      id: cardId,
      values: formData
    }
    dispatch(updatePCard(payload))
      .unwrap()
      .then((res) => {
        message.success(translate("ALERTS.SUCCESS_UPDATE"), 4);
        form.resetFields();
        navigate(`/newbussinescard?user=${res.UUID}&branch=${res.branch}`);
      })
      .catch((err) => {
        message.error(String(err), 3);
      });
  };

  return (
    <div className="bussines_card">
      <Form
        form={form}
        name="bussinesCard"
        initialValues={{
          branch: "",
          serial: "",
          name: "",
          ar_name: "",
          company: "",
          ar_company: "",
          job: "",
          ar_job: "",
          description: "",
          ar_description: "",
          phone1: "",
          phone2: "",
          whatsapp: "",
          website_url: "",
          map_url: "",
          tiktok_url:"",
          instagram_url:"",
          snapChat_url:"",
          catalog_url:"",
          email: "",
          employee: "",
          count1: 1,
          price: 0,
          cardImage: [],
          paymentType: "cash",
          createdDate: dayjs(),
        }}
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
      >
        <div className="row">
          {/* branch */}
          <div className="col-sm-12 col-md-6 col-lg-2">
            <Form.Item
              label={translate("FORM.BRANCH")}
              name="branch"
              rules={[{ required: true, message: "Please select branch!" }]}
            >
              <Select
                showSearch
                style={{ height: 40 }}
                placeholder="Select a branch"
                onChange={(value) => {
                  dispatch(getBussinesCradSerial(value))
                    .unwrap()
                    .then((res) => {
                      form.setFieldValue("serial", res);
                    })
                    .catch((err) => {
                      message.error(String(err), 4);
                    });
                }}
              >
                <Select.Option value="infoTech"> InfoTech </Select.Option>
                <Select.Option value="toplevel"> Top Level </Select.Option>
              </Select>
            </Form.Item>
          </div>

          {/* serial */}
          <div className="col-sm-12 col-md-6 col-lg-2">
            <Form.Item
              label={translate("FORM.SERIAL")}
              name="serial"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} disabled />
            </Form.Item>
          </div>

          {/* english  name */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <Form.Item
              label={translate("FORM.ENGNAME")}
              name="name"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* arbic name*/}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <Form.Item
              label={translate("FORM.ARNAME")}
              name="ar_name"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* english company name*/}
          <div className="col-sm-12 col-md-6 col-lg-3">
            <Form.Item
              label={translate("FORM.ENGCOMPANY")}
              name="company"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* arabic company name  */}
          <div className="col-sm-12 col-md-6 col-lg-3">
            <Form.Item
              label={translate("FORM.ARCOMPANY")}
              name="ar_company"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* english job name  */}
          <div className="col-sm-12 col-md-6 col-lg-3">
            <Form.Item
              label={translate("FORM.ENGJOB")}
              name="job"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* arabic job name  */}
          <div className="col-sm-12 col-md-6 col-lg-3">
            <Form.Item
              label={translate("FORM.ARJOB")}
              name="ar_job"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/* english description name  */}
          <div className="col-sm-12 col-md-12 col-lg-6">
            <Form.Item
              label={translate("FORM.ENGDESCRIPTION")}
              name="description"
              rules={[{ required: true }]}
            >
              <Input.TextArea maxLength={150} style={{ height: 100 }} />
            </Form.Item>
          </div>
          {/* arabic description name  */}
          <div className="col-sm-12 col-md-12 col-lg-6">
            <Form.Item
              label={translate("FORM.ARDESCRIPTION")}
              name="ar_description"
              rules={[{ required: true }]}
            >
              <Input.TextArea maxLength={150} style={{ height: 100 }} />
            </Form.Item>
          </div>
          {/*phone1 */}
          <div className="col-sm-12 col-md-4 col-lg-2">
            <Form.Item
              label={translate("FORM.PHONE1")}
              name="phone1"
              rules={[{ required: true }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*phone2 */}
          <div className="col-sm-12 col-md-4 col-lg-2">
            <Form.Item label={translate("FORM.PHONE2")} name="phone2">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*whatsapp */}
          <div className="col-sm-12 col-md-4 col-lg-2">
            <Form.Item label={translate("FORM.WHATSAPP")} name="whatsapp">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*email */}
          <div className="col-sm-12 col-md-12 col-lg-3">
            <Form.Item
              name="email"
              label={translate("FORM.EMAIL")}
              rules={[{ type: "email" }]}
            >
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*website */}
          <div className="col-sm-12 col-md-12 col-lg-3">
            <Form.Item label={translate("FORM.WEBSITURL")} name="website_url">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*map url */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <Form.Item label={translate("FORM.GOOGLEMAPURL")} name="map_url">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*tiktok url */}
          <div className="col-sm-12 col-md-12 col-lg-4">
            <Form.Item label={translate("FORM.TIKTOKURL")} name="tiktok_url">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*instagram url */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <Form.Item label={translate("FORM.INSTAGRAMURL")} name="instagram_url">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*snapchat url */}
          <div className="col-sm-12 col-md-12 col-lg-4">
            <Form.Item label={translate("FORM.SNAPCHATURL")} name="snapChat_url">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*catalog url */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <Form.Item label={translate("FORM.CATALOGURL")} name="catalog_url">
              <Input style={{ height: 40 }} />
            </Form.Item>
          </div>
          {/*employee */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <Form.Item
              label={translate("FORM.EMPLOYEE")}
              name="employee"
              rules={[{ required: true }]}
            >
              <Select style={{ height: 40 }}>
                <Select.Option value="محمود مصطفي"> محمود مصطفي </Select.Option>
                <Select.Option value="أحمد جودة"> أحمد جودة </Select.Option>
                <Select.Option value="سامح أمين"> سامح أمين</Select.Option>
                <Select.Option value="محمد نصرالله">
                  {" "}
                  محمد نصرالله{" "}
                </Select.Option>
                <Select.Option value="أحمد راتب"> أحمد راتب </Select.Option>
              </Select>
            </Form.Item>
          </div>
          {/*date */}
          <div className="col-sm-12 col-md-6 col-lg-2">
            <Form.Item name="createdDate" label="Card Date">
              <DatePicker
                style={{ width: "100%", height: 40 }}
                format={"DD/MM/YYYY"}
              />
            </Form.Item>
          </div>
          {/*count */}
          <div className="col-sm-12 col-md-6 col-lg-1">
            <Form.Item label={translate("FORM.COUNT")} name="count1">
              <InputNumber style={{ width: "100%", height: 40 }} min={1} />
            </Form.Item>
          </div>
          {/*price */}
          <div className="col-sm-12 col-md-6 col-lg-1">
            <Form.Item label={translate("FORM.PRICE")} name="price">
              <InputNumber style={{ width: "100%", height: 40 }} min={0} />
            </Form.Item>
          </div>
          {/*payment type */}
          <div className="col-sm-12 col-md-12 col-lg-3">
            <Form.Item
              label={translate("FORM.PAYMENTTYPE")}
              name="paymentType"
              rules={[{ required: true }]}
            >
              <Select style={{ height: 40 }}>
                <Select.Option value="cash">
                  {translate("PAYMENTTYPE.CASH")}
                </Select.Option>
                <Select.Option value="card">
                  {translate("PAYMENTTYPE.CARD")}
                </Select.Option>
                <Select.Option value="transfer">
                  {translate("PAYMENTTYPE.TRANSFER")}
                </Select.Option>
              </Select>
            </Form.Item>
          </div>
          {/*cardImage */}
          <div className="col-sm-12 col-md-12 col-lg-4">
            <Form.Item
              name="cardImage"
              label={translate("FORM.IMAGE") || "Card Image"}
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload
                name="cardImage"
                listType="picture"
                multiple={false}
                beforeUpload={(file) => {
                  const isJpgOrPng =
                    file.type === "image/jpeg" || file.type === "image/png";
                  if (!isJpgOrPng) {
                    message.error(translate("ALERTS.ONLYJPGPNG"), 4);
                  }
                  const isLt2M = file.size / 1024 / 1024 < 2;
                  if (!isLt2M) {
                    message.error(translate("ALERTS.IMAGESIZE2M"), 4);
                  }
                  return false;
                }}
                maxCount={1}
              >
                <Button
                  icon={<UploadOutlined />}
                  style={{ width: "100%", height: 40 }}
                >
                  {translate("BUTTONS.UPLOAD")}
                </Button>
              </Upload>
            </Form.Item>
          </div>
        </div>

        <Form.Item>
          <Button
            className="d-block w-25 m-auto mt-3 fs-3 submit"
            style={{ height: 60, backgroundColor: "#1abc9c" }}
            type="primary"
            htmlType="submit"
          >
            {translate("BUTTONS.SAVE")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditPcardForm;
